/**
 * The schema manipulated here is not the complete schema in the schemas directory.
 *
 * Instead, it is the {fields, sortOrder} subset, and only for fields that have a position.
 *
 */

import {EntitySchema, SchemaField} from "../@types/schema";
import base from "../entities/base";

export type FieldWithName = SchemaField & {name?: string};

/**
 * Get a list of fields. Non-transient/non-base fields only.
 *
 * @param {EntitySchema} schema
 */
function getFields(schema: EntitySchema): FieldWithName[] {
    let fields = [];
    for (let fieldName in schema.fields) {
        const field: FieldWithName = schema.fields[fieldName];

        const isTransient = field['transient'];
        const isBase = field['base']

        if(!isTransient && !isBase) {
            field.name = fieldName;
            fields.push(field);
        }
    }

    return fields;
}

/**
 * Get a list of field names.  Defaults to non-transient field only.
 *
 * @param {EntitySchema} schema
 * @param {boolean} [ignoreBase]
 */
function getFieldNames(schema: EntitySchema, ignoreBase?: boolean): string[] {
    let fields: string[] = [];
    for (let fieldName in schema.fields) {
        const field = schema.fields[fieldName];

        const isTransient = field['transient'];
        const isBase = ignoreBase ? field['base'] : false;

        if(!isTransient && !isBase) {
            fields.push(fieldName);
        }
    }

    return fields;
}

/**
 * Get field names for the base fields
 */
function getBaseFieldNames() {
    const fieldNames: string[] = [];
    getFieldNames(base.getSchema()).forEach(fieldName => {
        const field = base.getSchema().fields[fieldName];

        // Ignore transient fields, ref fields, and readOnly fields (during a save)
        const isTransient = field['transient'];
        // const isReadOnly = field['readOnly'] === 'dbDefault';

        if (!isTransient) fieldNames.push(fieldName);
    });

    return fieldNames;
}

export default {
    getBaseFieldNames,
    getFields,
    getFieldNames,
}
